<template>
  <simple-card-dialog
    v-model:dialog="model"
    max-width="600"
    show-cancel
    :title="$t('Customer.Customer')"
  >
    <CustomerForm
      ref="form"
      :current-data="currentData"
      @form-data="updateFormData"
    />

    <template #actions>
      <action-button
        save
        @click="submit()"
      />
    </template>
  </simple-card-dialog>
</template>

<script>
  import CreateEditMixin from './CreateEditMixin'
  import CustomerForm from '@/components/forms/CustomerForm'

  export default {
    components: { CustomerForm },
    mixins: [CreateEditMixin],
    data: () => ({
      api: 'customers'
    })
  }
</script>
